
import React from 'react'
import { NavLink } from 'react-router-dom'
import {LayoutDashboard, Users, Package, FileText, FileCheck, UserCheck, Calendar, ClipboardList, ShoppingCart, DollarSign, Settings, ChevronLeft, ChevronRight, Building2, LogOut} from 'lucide-react'

interface SidebarProps {
  isCollapsed: boolean
  onToggle: () => void
  onLogout?: () => void
}

const Sidebar = ({ isCollapsed, onToggle, onLogout }: SidebarProps) => {
  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard Geral', path: '/' },
    { icon: Users, label: 'CRM', path: '/crm' },
    { icon: Package, label: 'Base de Insumos', path: '/insumos' },
    { icon: FileText, label: 'Orçamentos', path: '/orcamentos' },
    { icon: FileCheck, label: 'Contratos', path: '/contratos' },
    { icon: UserCheck, label: 'Funcionários', path: '/funcionarios' },
    { icon: Calendar, label: 'Planejamento de Obras', path: '/planejamento' },
    { icon: ClipboardList, label: 'Diário de Obra', path: '/diario-obra' },
    { icon: ShoppingCart, label: 'Compras', path: '/compras' },
    { icon: DollarSign, label: 'Financeiro', path: '/financeiro' },
    { icon: Settings, label: 'Usuários', path: '/usuarios' },
  ]

  return (
    <div className={`bg-white shadow-lg transition-all duration-300 ${
      isCollapsed ? 'w-16' : 'w-64'
    } min-h-screen relative`}>
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          {!isCollapsed && (
            <div className="flex items-center space-x-2">
              <Building2 className="w-8 h-8 text-blue-600" />
              <div>
                <h1 className="text-xl font-bold text-gray-800">GestPRO</h1>
                <span className="text-xs text-blue-600 font-medium">v2.0</span>
              </div>
            </div>
          )}
          {isCollapsed && (
            <Building2 className="w-8 h-8 text-blue-600 mx-auto" />
          )}
        </div>
      </div>

      {/* Toggle Button */}
      <button
        onClick={onToggle}
        className="absolute -right-3 top-20 bg-white border border-gray-200 rounded-full p-1 shadow-md hover:shadow-lg transition-shadow"
      >
        {isCollapsed ? (
          <ChevronRight className="w-4 h-4 text-gray-600" />
        ) : (
          <ChevronLeft className="w-4 h-4 text-gray-600" />
        )}
      </button>

      {/* Navigation */}
      <nav className="mt-4 px-2">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center px-3 py-3 mb-1 rounded-lg transition-colors duration-200 ${
                isActive
                  ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
          >
            <item.icon className={`w-5 h-5 ${isCollapsed ? 'mx-auto' : 'mr-3'}`} />
            {!isCollapsed && (
              <span className="font-medium">{item.label}</span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Logout Button */}
      {onLogout && (
        <div className="absolute bottom-4 left-2 right-2">
          <button
            onClick={onLogout}
            className="flex items-center w-full px-3 py-3 text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
          >
            <LogOut className={`w-5 h-5 ${isCollapsed ? 'mx-auto' : 'mr-3'}`} />
            {!isCollapsed && (
              <span className="font-medium">Sair</span>
            )}
          </button>
        </div>
      )}
    </div>
  )
}

export default Sidebar
